import { apiPost } from '../../api'

export const send_sms = data => {
  return apiPost({
    endpoint: `user/send_sms`,
    data: data
  })
}
